// SPDX-License-Identifier: AGPL-3.0-or-later

import * as GuildNotificationSoundCommands from '@app/features/guild/commands/GuildNotificationSoundCommands';
import {GuildNotificationSoundControl} from '@app/features/guild/components/GuildNotificationSoundControl';
import {SettingsSection} from '@app/features/guild/components/modals/guild_tabs/guild_overview_tab/components/GuildOverviewTabSettingsSection';
import Guilds from '@app/features/guild/state/Guilds';
import {Trans} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

export const NotificationSoundSection: React.FC<{guildId: string}> = observer(({guildId}) => {
	const guild = Guilds.getGuild(guildId);
	if (!guild) return null;
	return (
		<SettingsSection
			title={<Trans>Notification sound</Trans>}
			description={
				<Trans>Members hear this short sound for new messages here. They can switch back to the normal sound.</Trans>
			}
			data-flx="guild.guild-tabs.guild-overview-tab.notification-sound-section.settings-section"
		>
			<GuildNotificationSoundControl
				guildId={guildId}
				hash={guild.notificationSound}
				onSave={(audio) => GuildNotificationSoundCommands.setGuildNotificationSound(guildId, audio)}
				onRemove={() => GuildNotificationSoundCommands.removeGuildNotificationSound(guildId)}
				dataFlx="guild.guild-tabs.guild-overview-tab.notification-sound-section"
			/>
		</SettingsSection>
	);
});

NotificationSoundSection.displayName = 'NotificationSoundSection';
